<template>
	<div class="userAgreement">
    <label v-bind:class="{'on': userAgreementChecked, 'disabled': isDisabled}" class="checkbox blu-checkbox is-primary">
      <input v-if="isRequired" v-bind:disabled="isDisabled" v-model='userAgreementChecked' type="checkbox" :name="$t('links.userAgreement')" :value=userAgreementChecked v-validate="'required'" data-vv-validate-on="change|custom">
      <input v-if="!isRequired" v-bind:disabled="isDisabled" v-model='userAgreementChecked' type="checkbox" :name="$t('links.userAgreement')" :value=userAgreementChecked >
       <span v-bind:class="{'disabled': isDisabled}">
          <modal :is-show="itemDetailShow" :show-footer=false transition="fadeDown" @close="itemDetailShow=false">
		        <div class="is-center" style="height:100%">
              <iframe id="the-iframe" :src="srcData" width="100%" height="100%" frameborder="0"></iframe>
		        </div>
	        </modal>
         <template v-if="$i18n.locale === 'tr'">
          <a v-bind:class="{'a-disabled': isDisabled}" v-on:click.stop.prevent='openUserAgreement'>{{ $t("links.userAgreement") }}</a> {{ $t("links.readAndApproved") }}.
        </template>

        <template v-if="$i18n.locale === 'en'">
          {{ $t("links.readAndApproved") }} <a v-bind:class="{'a-disabled': isDisabled}" v-on:click.stop.prevent='openUserAgreement'>{{ $t("links.userAgreement") }}</a>.
        </template>
      </span>
    	<span v-if="errors.has($t('links.userAgreement'))" class="help is-danger">{{ errors.first($t('links.userAgreement')) }}</span>
      
    </label>
	</div>
</template>

<script>
import service from '@/service'
import UserAgreementPopup from '@/shared/widget/legalInfo/UserAgreement'
export default {
  name: 'UserAgreement',
  components: {
    UserAgreementPopup
  },
  data () {
    return {
      itemDetailShow: false,
      srcData: '',
      userAgreementChecked: (this.isUserAgreementChecked && !this.isDisabled),
      healthInsurance: false
    }
  },
  inject: [ 'parentValidator' ],
  created () {
    this.$validator = this.parentValidator
  },
  props: {
    isUserAgreementChecked: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: null
    },
    interactionType: {
      type: Number,
      default: 0
    },
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
  },
  methods: {
    openUserAgreement: function () {
      this.itemDetailShow = true
      var data = {
        extension: 'pdf',
        filename: this.interactionType !== 3 ? 'd5fe7046e19c44b6a81359a8e69cc59f' : 'f046a4a5e3784fb6a367ebf88cac846b'
      }
      this.srcData = service.content.contentUrl(data.extension, data.filename)
    }
  },
  watch: {
    userAgreementChecked: function () {
      this.$emit('input', this.userAgreementChecked)
    }
  }
}
</script>

<style scoped>
  a {
    text-decoration: underline;
    font-size: 1em;
    font-weight: bold;
    color: var(--text-color9);
  }
  div >>> .modal-card {
    width: 90%;
    max-width: 90%;
    height: 75%;
    max-height: 75%;
  }
</style>


// WEBPACK FOOTER //
// src/shared/widget/legalInfo/agreement/userAgreement.vue